import { Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { CopyableText } from '../text/CopyableText.tsx';

const { Text } = Typography;

export interface ICopyableIdProps {
  id?: string | null;
}

/**
 * Componente che mostra un ID copiabile.
 */
export function CopyableId(props: ICopyableIdProps) {
  const { id } = props;
  const { t } = useTranslation();

  // Opzioni per il componente di copia
  const copyableOptions = {
    tooltips: id
      ? [
          t('table.copyable-id.copy', 'Copia ID: {{id}}', { id }),
          t('table.copyable-id.copied', 'ID: {{id}} copiato!', { id }),
        ]
      : [t('table.copyable-id.no-id', 'ID non presente!'), ''],
    text: id ?? t('table.copyable-id.no-id', 'ID non presente!'),
  };

  return <CopyableText copyable={copyableOptions} />;
}
